<template>
	<div class="container">
		<div class="common-header-wrap">
			<mt-header class="common-header" :title="$t('Forgot Password')">
				<mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
			</mt-header>
		</div>

		<div class="main-content">
			<!-- <div class="topList">
				<div class="list">
					<div class="item">
						<label class="title active">{{ $t('Forgot Password') }}</label>
					</div>
				</div>
			</div> -->
			<div class="top-wrapper">
				<!-- 用户名: Username -->
				<flex-line class="field-line input-wrapper" :show-border="true">
					<span class="field-name">
						{{ $t('Username') }}
					</span>
					<div class="field-line-right" slot="right">
						<input class="field-input" v-model="member_name" :placeholder="$t('Please enter')" />
					</div>
				</flex-line>
				<flex-line class="field-line input-wrapper" :show-border="true">
					<span class="field-name">
						{{ $t('Enter Email') }}
					</span>
					<div class="field-line-right" slot="right">
						<input class="field-input" type="text" v-model="username" :placeholder="$t('Please enter')"
							:attr="{ oninput: 'if(value.length>11)value=value.slice(0,11)' }" />
					</div>
				</flex-line>
				<flex-line class="field-line input-wrapper" :show-border="true">
					<span class="field-name">
						{{ $t('Verification Code') }}
					</span>
					<div class="field-line-right" slot="right">
						<input class="field-input" type="number" v-model="verifyCodeMobile"
							:placeholder="$t('Please enter')"
							:attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" />
						<div @click="sendVerifyCodeMobile" class="common-btn send-btn">{{ sendStateTextMobile }}</div>
					</div>
				</flex-line>
				<flex-line class="field-line input-wrapper" :show-border="true" :showPassword="showPassword"
					:toggleVisibility="toggleVisibility" :isPassword="true">
					<span class="field-name">
						{{ type == 'pay_password' ? $t('New Payment Password') : $t('Set Password') }}
					</span>
					<div class="field-line-right" slot="right">
						<input class="field-input" :type="showPassword ? 'text' : 'password'" v-model="password"
							:placeholder="$t('Please enter')" />
					</div>
				</flex-line>
				<flex-line class=" field-line input-wrapper" :show-border="true" :showPassword="showPassword2"
					:toggleVisibility="toggleVisibility2" :isPassword="true">
					<span class="field-name">
						{{ $t('Confirm Password') }}
					</span>
					<div class="field-line-right" slot="right">
						<input class="field-input" :type="showPassword2 ? 'text' : 'password'" v-model="confirmPassword"
							:placeholder="$t('Please enter')" />
						<!-- <label v-if="!confirmPassword" class="tips">{{ $t('6-20 digits/letters/symbols') }}</label> -->
					</div>
				</flex-line>
			</div>
			<!-- <div class="find_the_password_help">
				{{ $t('Forget.email.tips') }}
			</div> -->
			<div class="common-btn ds-button-large mt-10" @click="onSubmit">{{ $t('confirm') }}</div>
		</div>
	</div>
</template>

<script>
import { forget, forgetEmail } from '../../../api/memberForget'
import { getSmsCaptcha, getEmailCode } from '../../../api/common'
import { mapMutations, mapActions, mapState } from 'vuex'
import { Toast } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
	name: 'HomeMemberForget',
	components: {
		flexLine
	},
	data() {
		return {
			member_name: '',
			username: '',
			password: '',
			confirmPassword: '',
			verifyCodeMobile: '',
			canSendMobile: true,
			timeIntervalMobile: false,
			sendStateTextMobile: this.$t('send'),
			showPassword: false,
			showPassword2: false,
			type: this.$route.query.type ? this.$route.query.type : 'password',
		}
	},
	mounted() {
		console.log(this.$route);
	},
	beforeDestroy: function () {
		clearInterval(this.timeIntervalMobile)
	},
	methods: {
		...mapMutations({
			saveAuthInfo: 'memberLogin'
		}),
		toggleVisibility() {
			this.showPassword = !this.showPassword;
		},
		toggleVisibility2() {
			this.showPassword2 = !this.showPassword2;
		},
		onSubmit() {
			if (!this.member_name || !this.username || !this.verifyCodeMobile || !this.password || !this.confirmPassword) {
				Toast(this.$t('Please complete the form'));
				return
			}

			forgetEmail(this.member_name, this.username, this.verifyCodeMobile, this.password, this.confirmPassword, this.type).then(
				response => {
					if (response.code == 10000) {
						// this.saveAuthInfo({ token: response.result.token, info: response.result.info })
						Toast(response.msg || this.$t('succ'))

						setTimeout(() => {
							// this.$router.push({ name: 'MemberIndex' })
							if (this.type == 'pay_password') {
								this.$router.back()
							} else {
								this.$router.push({ name: 'HomeMemberLogin' })
							}
						}, 500);
					} else {
						Toast(response.msg)
					}
				},
				error => {
					Toast(error.message)
				}
			)
			// forget(this.username, this.verifyCodeMobile, this.password, this.confirmPassword).then(
			// 	response => {
			// 		this.saveAuthInfo({ token: response.result.token, info: response.result.info })
			// 		this.$router.push({ name: 'MemberIndex' })
			// 	},
			// 	error => {
			// 		Toast(error.message)
			// 	}
			// )
		},
		sendVerifyCodeMobile() {
			if (!this.member_name || !this.username) {
				Toast(this.$t('Please enter'));
				return
			}

			if (!this.canSendMobile) {
				return
			}
			getEmailCode(this.username, this.member_name).then(res => {
				if (res.code != 10000) {
					Toast(res.msg)
					return
				}
				this.canSendMobile = false
				let second = 60
				Toast(res.msg)
				let _this = this
				this.timeIntervalMobile = setInterval(function () {
					if (second <= 0) {
						_this.canSendMobile = true
						_this.sendStateTextMobile = _this.$t('send')
						clearInterval(_this.timeIntervalMobile)
					} else {
						_this.sendStateTextMobile = second + 's'
					}

					second--
				}, 1000)
			}).catch(function (error) {
				Toast(error.message)
			})
			// getSmsCaptcha(3, this.username).then(res => {
			// 	this.canSendMobile = false
			// 	let second = 60
			// 	Toast(res.message)
			// 	let _this = this
			// 	this.timeIntervalMobile = setInterval(function () {
			// 		if (second <= 0) {
			// 			_this.canSendMobile = true
			// 			_this.sendStateTextMobile = this.$t('send')
			// 			clearInterval(_this.timeIntervalMobile)
			// 		} else {
			// 			_this.sendStateTextMobile = second + 's'
			// 		}

			// 		second--
			// 	}, 1000)
			// }).catch(function (error) {
			// 	Toast(error.message)
			// })
		}
	}
}
</script>

<style scoped lang="scss">
.ds-button-large {
	width: 80%;
	margin: 1rem auto 0;
	background: #E7010C;
	padding: .2rem;
}

.container {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	background: #fff;
	min-height: 100vh;
	box-sizing: border-box;

	.main-content {
		background: #fff;
		padding: 1rem 0;
	}

	.input-wrapper {
		display: flex;
		flex-direction: row;
		align-content: flex-start;
		align-items: center;
		background-color: #fff;
		// height: 2.2rem;
		// padding-left: 0.5rem;

		flex-direction: column;
		align-items: flex-start;
		margin: .4rem 0;

		.field-name {
			width: 100%;
			font-size: 14px;
			font-weight: 600;
			margin: .5rem 0;
		}

		input {
			flex: 1;
			font-size: $subFontSize;
			flex: 1;
			// width: 14.5rem;
			width: 100%;
			text-align: left;
			// border: 1px solid #cccccc;
			padding: .9rem;
			border-radius: .4rem;
			background: #FAFAFA;
			border-radius: 5px 5px 5px 5px;
		}

		.bottom-input {
			border-bottom-width: 0;
		}

		.field-line-right {
			width: 100%;
			position: relative;
		}

		::v-deep(.right) {
			width: 100%;
		}
	}
}

.top-wrapper {
	margin: 0 1rem;
}

.bottom-wrapper {
	margin-top: 0.5rem;
}

.tips {
	color: $descTextColor;
	font-size: $fontSize;
	white-space: nowrap;
	position: absolute;
	right: 0;
	top: 50%;
	margin-top: -.3rem;
}

.field-line-right {
	position: relative
}

.send-btn {
	// border: 1px solid $primaryColor;
	color: $primaryColor;
	min-width: 2rem;
	position: absolute;
	top: 50%;
	right: .2rem;
	transform: translate(0, -50%);
}

.topList {
	height: 2rem;
	padding: 1rem $pageSpace;

	.list {
		height: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-content: center;
		align-items: stretch;
		background-color: #fff;
	}

	.item {
		padding: 0 .5rem;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.title {
		text-align: center;
		font-size: $h2;
		color: $formInputColor;
	}

	.active {
		color: $primaryColor;
		font-size: 1.1rem;
	}

	.normal {
		color: #404245;
	}

}

.find_the_password_help {
	margin: 0 .6rem;
	font-size: $subFontSize;
	padding-top: .5rem;
	color: $descTextColor
}

.field-input {
	text-align: left !important;
}
</style>
